import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';

import { createNoteForm, toggleCreateNoteForm } from 'services/annotations/duck';
import EditNoteForm from 'components/organisms/forms/EditNote';

class CreateNoteContainer extends Component {
    render() {
        return (
            <EditNoteForm
                dispatch={this.props.dispatch}
                handleToggle={this.props.toggleCreateNoteForm}
                formHeader='New Note'
                handleSubmit={this.props.handleSubmit.bind(null, createNoteForm)} >
                {this.props.children}
            </EditNoteForm>
        );
    }
}

const form = 'createNote';

const mapStateToProps = (state, props) => ({
    initialValues: {
        handleToggle: props.handleToggle,
        type: 'NOTE',
        provider: 'ml-api',
        meta: {
            entityId: props.entityId,
            dashboard: props.dashboard,
            start: state.config.selectedTimeRange.apiConfig.start().format('MM-DD-YYYY'),
            end: state.config.selectedTimeRange.apiConfig.end().format('MM-DD-YYYY'),
            content: ''
        }
    },
});

export default compose(
    connect(mapStateToProps, {
        toggleCreateNoteForm,
    }),
    reduxForm({
        form,
        enableReinitialize: false
    })
)(CreateNoteContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/CreateNoteContainer.js